module.exports = __webpack_public_path__ + "images/help/video-invite@2x-7131db75e52065e7d75cf5d88f6585b1.png";